module.exports = __webpack_public_path__ + "img/cart-plus.126490a5.svg";